package com.jingfangpai.medicalRecord.model

import com.jingfangpai.common.orm.mapping.enums.MedicalRecordPatientSex
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordPersonType
import com.jingfangpai.smartTcm.model.DiagnosisQuestionAndAnswerItem
import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordRawData {
    var medicalRecordId:String?= null
    var patientId:String? = null
    var patientSex:MedicalRecordPatientSex? = null
    var personType:Set<MedicalRecordPersonType> = setOf()
    var questionAndAnswers:Array<DiagnosisQuestionAndAnswerItem> = arrayOf()
    var isDoctor:Boolean = false
    var source:String? = null
    var createdBy:String?=null
}